import { Outlet } from "react-router-dom";
import LayoutAdmin from "./UI/Layout-admin";
import DashboardLayout from "./Admin/dashboard-layout";

const Admin = () => {
  return (
    <LayoutAdmin>
      <DashboardLayout>
        <Outlet />
      </DashboardLayout>
    </LayoutAdmin>
  );
};

export default Admin;
